import { render, staticRenderFns } from "./main-header-sub.vue?vue&type=template&id=2a457b01&scoped=true&"
import script from "./main-header-sub.vue?vue&type=script&lang=ts&"
export * from "./main-header-sub.vue?vue&type=script&lang=ts&"
import style0 from "./main-header-sub.vue?vue&type=style&index=0&id=2a457b01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a457b01",
  null
  
)

export default component.exports